var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.96875C11.2188 0.96875 14.2812 4.03125 14.2812 7.75C14.2812 11.4961 11.2188 14.5312 7.5 14.5312C3.75391 14.5312 0.71875 11.4961 0.71875 7.75C0.71875 4.03125 3.75391 0.96875 7.5 0.96875ZM7.5 3.97656C6.84375 3.97656 6.35156 4.49609 6.35156 5.125C6.35156 5.78125 6.84375 6.27344 7.5 6.27344C8.12891 6.27344 8.64844 5.78125 8.64844 5.125C8.64844 4.49609 8.12891 3.97656 7.5 3.97656ZM9.03125 10.9219V10.2656C9.03125 10.1016 8.86719 9.9375 8.70312 9.9375H8.375V7.20312C8.375 7.03906 8.21094 6.875 8.04688 6.875H6.29688C6.10547 6.875 5.96875 7.03906 5.96875 7.20312V7.85938C5.96875 8.05078 6.10547 8.1875 6.29688 8.1875H6.625V9.9375H6.29688C6.10547 9.9375 5.96875 10.1016 5.96875 10.2656V10.9219C5.96875 11.1133 6.10547 11.25 6.29688 11.25H8.70312C8.86719 11.25 9.03125 11.1133 9.03125 10.9219Z",
    stroke: "none"
  })));
};
export default __webpack_public_path__ + "assets/b12601ab19a40b945afb4987dc34df82.svg";
export { SvgInfo as ReactComponent };


// WEBPACK FOOTER //
// ./components/modals/Modal2/icons/info.svg